export const appModule = {
  PASSENGER: 'passenger',
  OPERATIONAL: 'operational',
  LITE: 'lite',
  SESSION: 'session',
  EXTERNAL: 'external',
  GIS: 'gis',
}
